module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020/0064.jpg?v=b7ec3218";